import {
    CREATE_ANNOTATION_FAILURE,
    CREATE_ANNOTATION_REQUEST,
    CREATE_ANNOTATION_SUCCESS,
    DELETE_ANNOTATION_FAILURE,
    DELETE_ANNOTATION_REQUEST,
    DELETE_ANNOTATION_SUCCESS,
    GET_ANNOTATIONS_FAILURE,
    GET_ANNOTATIONS_REQUEST,
    GET_ANNOTATIONS_SUCCESS,
    GET_MY_ANNOTATIONS_FAILURE,
    GET_MY_ANNOTATIONS_REQUEST,
    GET_MY_ANNOTATIONS_SUCCESS,
    UPDATE_ANNOTATION_FAILURE,
    UPDATE_ANNOTATION_REQUEST,
    UPDATE_ANNOTATION_SUCCESS,
} from "./actions";

const initialState = {
    annotationsByRecordKey: {},
    myAnnotations: [],
    getAnnotationsResult: {},
    getMyAnnotationsResult: {},
    createAnnotationResult: {},
    updateAnnotationResult: {},
    deleteAnnotationResult: {},
};

const upsertRecordCollection = (state, recordKey, updater) => {
    const collection = state.annotationsByRecordKey[recordKey] || { Items: [] };
    const updated = updater(collection);
    return {
        ...state.annotationsByRecordKey,
        [recordKey]: updated,
    };
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_ANNOTATIONS_REQUEST:
            return {
                ...state,
                getAnnotationsResult: { loading: true },
            };
        case GET_ANNOTATIONS_SUCCESS: {
            const { recordKey, annotations } = action.payload;
            return {
                ...state,
                annotationsByRecordKey: {
                    ...state.annotationsByRecordKey,
                    [recordKey]: annotations || { Items: [] },
                },
                getAnnotationsResult: { success: true },
            };
        }
        case GET_ANNOTATIONS_FAILURE:
            return {
                ...state,
                getAnnotationsResult: { error: action.payload.error },
            };

        case CREATE_ANNOTATION_REQUEST:
            return {
                ...state,
                createAnnotationResult: { loading: true },
            };
        case CREATE_ANNOTATION_SUCCESS: {
            const { recordKey, annotation } = action.payload;
            const annotationsByRecordKey = upsertRecordCollection(state, recordKey, (collection) => ({
                ...collection,
                Items: [annotation, ...(collection.Items || []).filter((item) => item.annotationId !== annotation.annotationId)],
            }));
            return {
                ...state,
                annotationsByRecordKey,
                createAnnotationResult: { success: true },
            };
        }
        case CREATE_ANNOTATION_FAILURE:
            return {
                ...state,
                createAnnotationResult: { error: action.payload.error },
            };

        case UPDATE_ANNOTATION_REQUEST:
            return {
                ...state,
                updateAnnotationResult: { loading: true },
            };
        case UPDATE_ANNOTATION_SUCCESS: {
            const { recordKey, annotation } = action.payload;
            const annotationsByRecordKey = upsertRecordCollection(state, recordKey, (collection) => ({
                ...collection,
                Items: (collection.Items || []).map((item) => (item.annotationId === annotation.annotationId ? annotation : item)),
            }));
            return {
                ...state,
                annotationsByRecordKey,
                updateAnnotationResult: { success: true },
            };
        }
        case UPDATE_ANNOTATION_FAILURE:
            return {
                ...state,
                updateAnnotationResult: { error: action.payload.error },
            };

        case DELETE_ANNOTATION_REQUEST:
            return {
                ...state,
                deleteAnnotationResult: { loading: true },
            };
        case DELETE_ANNOTATION_SUCCESS: {
            const { recordKey, annotationId } = action.payload;
            const annotationsByRecordKey = upsertRecordCollection(state, recordKey, (collection) => ({
                ...collection,
                Items: (collection.Items || []).filter((item) => item.annotationId !== annotationId),
            }));
            return {
                ...state,
                annotationsByRecordKey,
                deleteAnnotationResult: { success: true },
            };
        }
        case DELETE_ANNOTATION_FAILURE:
            return {
                ...state,
                deleteAnnotationResult: { error: action.payload.error },
            };

        case GET_MY_ANNOTATIONS_REQUEST:
            return {
                ...state,
                getMyAnnotationsResult: { loading: true },
            };
        case GET_MY_ANNOTATIONS_SUCCESS:
            return {
                ...state,
                myAnnotations: Array.isArray(action.payload.annotations?.Items)
                    ? action.payload.annotations.Items
                    : Array.isArray(action.payload.annotations)
                      ? action.payload.annotations
                      : [],
                getMyAnnotationsResult: { success: true },
            };
        case GET_MY_ANNOTATIONS_FAILURE:
            return {
                ...state,
                getMyAnnotationsResult: { error: action.payload.error },
            };

        default:
            return state;
    }
}
